import React, { Fragment } from 'react';
import { parseForMarkdownLinks } from '../../helpers';
import './style.scss';

function TwoColumns({content}) {
  return (
    <div className="TwoColumns">
      {content?.editor?.map((section, index) => (
        <Fragment key={section.title + "-" + index}>
          <h2 className="TwoColumns__title">{section.title}</h2>
          <div
            className="TwoColumns__paragraphs"
            dangerouslySetInnerHTML={{
              __html: parseForMarkdownLinks(section.text, content.link_color)
            }}
          />
        </Fragment>
      ))}
    </div>
  );
}

export default TwoColumns;
